import PromisifySync from 'newModels/mixins/promisify-sync.js';
import LoopbackFetch from './mixins/loopback-fetch.js';
import Paginatable from './mixins/paginatable.js';
import Searchable from './mixins/searchable.js';
import config from 'config';
import axios from 'axios';

/* TODO this is awful, I very briefly experimented with the idea of making a
 * compose function but it was throwing a weird type error so I reverted back
 * to this "way" of composing functions. Should try again sometime.
 * TODO Do we want to make all collections searchable and paginatable?
 */
export default class extends (
    Searchable(Paginatable(LoopbackFetch(PromisifySync(Backbone.Collection))))
) {
    initialize(models, options) {
        this.removedModels = [];
        this.searchableAttributes = [];
        this.searchTerm = '';

        this.options = Object.assign({
            syncRemove: false,
            sortKey: null,
            sortOrder: null
        }, options || {});

        if (this.options.syncRemove) {
            this.on('remove', this.destroyLater, this);
        }
        this.on('reset', this.invalidateModelsAfterReset, this);

        return super.initialize(...arguments);
    }

    comparator(a, b) {
        if (typeof this.options.sortKey !== 'string') {
            return 0;
        }

        if (
            typeof (a || {}).get !== 'function' ||
            typeof (b || {}).get !== 'function'
        ) {
            return;
        }

        a = a.get(this.options.sortKey);
        b = b.get(this.options.sortKey);

        return this.valueComparator(a, b);
    }

    valueComparator(a, b) {
        const order = this.options.sortOrder || 'ascending';

        if (typeof a === 'string') {
            a = a.toLowerCase();
        }
        if (typeof b === 'string') {
            b = b.toLowerCase();
        }

        if (a instanceof Date) {
            a = a.getTime();
        }
        if (b instanceof Date) {
            b = b.getTime();
        }

        return (order === 'ascending') ? (
            a < b ? -1 :
                a > b ? 1 :
                    0
        ) : (
            a < b ? 1 :
                a > b ? -1 :
                    0
        );
    }

    setOptions(options) {
        this.options = Object.assign(this.options, options || {});
    }

    isNew() {
        return this.reduce((memo, model) => {
            return memo && model.isNew();
        }, true);
    }

    isValid() {
        return this.reduce(
            (memo, model) => memo && model.isValid(),
            true
        );
    }

    getSort() {
        return {
            key: this.options.sortKey,
            order: this.options.sortOrder
        };
    }

    finalUrl() {
        return config.apiUrl + _.result(this, 'url');
    }

    dirty() {
        return this.reduce((m, model) => {
            return m || (model.dirty() || model.isNew());
        }, false) || (this.removedModels.length > 0);
    }

    count(where = {}) {
        const url = this.finalUrl() + '/count';
        return axios({
            method: 'get',
            url: url,
            params: {where: where},
            headers: {'Authorization': app.user.getAccessToken().id}
        }).then(({data}) => data.count || 0);
    }

    fetch(options = {}) {
        const sorting = this.getSort();
        const filter = Object.assign(
            this.options.filter || {},
            options.filter || {}
        );

        if (sorting.key) {
            filter.order = sorting.key + ' ' + (
                sorting.order === 'descending' ? 'DESC' : 'ASC'
            );
        }

        return super.fetch(Object.assign(options, {filter}));
    }

    headers() {
        let r = {};
        if (app.user) {
            const accessToken = app.user.getAccessToken();
            if (accessToken && accessToken.id) {
                r = Object.assign(r, {
                    'Authorization': accessToken.id
                });
            }
        }

        return r;
    }

    sync(method, collection, options) {
        options = Object.assign({}, options || {}, {
            url: config.apiUrl + _.result(collection, 'url')
        });
        options.headers = Object.assign(
            {}, options.headers || {}, this.headers()
        );
        return super.sync(method, collection, options);
    }

    save() {
        return Promise.all(
            this.filter(model => model.dirty() || model.isNew())
                .map(model => {
                    return model.save().then(() => model.fetch());
                })
        ).then(() => {
            if (!this.options.syncRemove || this.removedModels.length === 0) {
                return Promise.resolve();
            }

            return Promise.join(
                this.removedModels.map(model => model.destroy())
            ).then(() => this.removedModels = []);
        }).then(() => this);
    }

    destroyLater(model) {
        if (!model.id) {
            return;
        }

        if (!this.removedModels.find(m => m.id === model.id)) {
            this.removedModels.push(model);
        }
        return this;
    }

    invalidateModelsAfterReset(collection, options) {
        if (options.previousModels && options.previousModels.length > 0) {
            this.forEach(model => {
                const oldModel =
                    options.previousModels.find(m => m.id === model.id);
                if (oldModel) {
                    const changes = {};
                    Object.keys(model.attributes).forEach(attr => {
                        if (!_.isEqual(
                            model.attributes[attr], oldModel.attributes[attr]
                        )) {
                            changes[attr] = model.attributes[attr];
                        }
                    });
                    Object.keys(oldModel.unsavedAttributes).forEach(attr => {
                        if (_.isEqual(
                            model.attributes[attr],
                            oldModel.unsavedAttributes[attr]
                        )) {
                            changes[attr] = model.attributes[attr];
                        }
                    });
                    model.unsavedAttributes = Object.assign(
                        model.unsavedAttributes,
                        changes
                    );
                }
            });
        }
    }
}




// WEBPACK FOOTER //
// ./app/new-collections/collection.js